import React, { FC } from 'react';
import { Create, SimpleForm, useCreatePath, useNotify, useRedirect } from 'react-admin';
import { Typography, Container } from '@mui/material';
import { palette } from '../../../Theme';
import WithRole from 'src/components/common/WithRole';
import ShsFormToolbar from 'src/components/common/ShsFormToolbar';
import NoAccess from 'src/components/common/Errors/NoAccess';
import { LawInputsCard } from '../common/LawInputsCard';
import { NOTIFICATION_OPTIONS_SUCCESS, Resource } from 'src/constants';
import { UserRole } from 'src/auth/types';
import { ShsReturnButton, ShsSuccessNotification } from 'src/components/common';

interface Law {
    name: string;
    link: string;
}

export const CreateLaw: FC = () => {
    const redirect = useRedirect();
    const createPath = useCreatePath();
    const notify = useNotify();

    const handleCancelBtnClick = () => {
        redirect(createPath({ resource: 'laws', type: 'list' }));
    };

    const transform = (data: Law) => ({
        ...data,
        name: data.name.trim()
    });

    return (
        <WithRole roles={[UserRole.SYSTEM_ADMIN, UserRole.SECRETARIAT]} orElse={<NoAccess />}>
            <Container>
                <ShsReturnButton
                    to={createPath({ resource: 'laws', type: 'list' })}
                    label="Назад до законодавства"
                    sx={{ color: palette.primary.grayBluish }}
                />
                <Typography fontSize={40} fontWeight={700} sx={{ mb: 3 }}>
                    Додати НПА
                </Typography>

                <Create
                    transform={transform}
                    mutationOptions={{
                        onSuccess: () => {
                            notify(
                                <ShsSuccessNotification message="Нормативно-правовий акт успішно додано" />,
                                NOTIFICATION_OPTIONS_SUCCESS
                            );
                            redirect('list', Resource.LAWS);
                        }
                    }}
                    sx={{ '.RaCreate-card': { backgroundColor: 'transparent', boxShadow: 'none' } }}>
                    <SimpleForm toolbar={false} mode="onBlur" sx={{ padding: 0 }}>
                        <LawInputsCard />
                        <ShsFormToolbar
                            enableSaveButton={true}
                            submitLabel="Додати НПА"
                            handleCancel={handleCancelBtnClick}
                        />
                    </SimpleForm>
                </Create>
            </Container>
        </WithRole>
    );
};
